import { createTheme } from '@mui/material/styles';

export const muiTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#a5a4a4', // SILVER (Your Logo Color)
      light: '#ffffff',
      dark: '#6b6b6b',
      contrastText: '#000000',
    },
    secondary: {
      main: '#ffffff', // WHITE
      light: '#f0f0f0',
      dark: '#a5a4a4',
      contrastText: '#000000',
    },
    background: {
      default: '#000000', // PURE BLACK (Your Logo Color)
      paper: '#111111',   // Slightly lighter black for cards
    },
    text: {
      primary: '#ffffff',
      secondary: '#a5a4a4', // SILVER
    },
    divider: 'rgba(165, 164, 164, 0.2)', // SILVER Divider everywhere
    success: {
      main: '#27c93f',
    },
    error: {
      main: '#ff5f56',
    },
  },
  
  typography: {
    fontFamily: "'Inter', sans-serif",
    h1: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
      letterSpacing: '-0.5px',
    },
    h2: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
      letterSpacing: '-0.5px',
    },
    h3: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
    },
    h4: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
    },
    h5: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 500,
    },
    h6: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 500,
    },
    subtitle1: {
      fontWeight: 600,
      letterSpacing: '0.5px',
    },
    button: {
      textTransform: 'none',
      fontWeight: 700,
      letterSpacing: '1px',
    },
    overline: {
      fontWeight: 600,
      letterSpacing: '3px',
    },
  },

  shape: {
    borderRadius: 4,
  },

  components: {
    // Global Button Overrides (Silver & White Gradient)
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          fontWeight: 700,
          transition: 'all 0.3s ease',
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #a5a4a4 0%, #ffffff 100%)', // SILVER TO WHITE
          color: '#000000',
          '&:hover': {
            background: 'linear-gradient(135deg, #ffffff 0%, #a5a4a4 100%)',
            boxShadow: '0 10px 30px rgba(165, 164, 164, 0.4)',
            transform: 'translateY(-2px)',
          },
        },
        outlinedPrimary: {
          borderColor: '#a5a4a4',
          color: '#a5a4a4',
          '&:hover': {
            borderColor: '#ffffff',
            color: '#ffffff',
            backgroundColor: 'rgba(165, 164, 164, 0.1)',
          },
        },
      },
    },

    // AppBar Override (FIXED TO DARK)
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(0, 0, 0, 0.95)', // PURE BLACK
          color: '#ffffff',
          backdropFilter: 'blur(10px)',
        },
      },
    },

    // TextField Overrides (Silver Focus State)
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            color: '#ffffff',
            '& fieldset': { borderColor: 'rgba(165, 164, 164, 0.3)' },
            '&:hover fieldset': { borderColor: '#a5a4a4' },
            '&.Mui-focused fieldset': { borderColor: '#ffffff' },
          },
          '& .MuiInputLabel-root': { color: '#a5a4a4' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
        },
      },
    },

    // Chip Overrides
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          borderRadius: '4px',
        },
      },
    },
  },
});